import { render, staticRenderFns } from "./jPop.vue?vue&type=template&id=5120c966&scoped=true"
import script from "./jPop.vue?vue&type=script&lang=js"
export * from "./jPop.vue?vue&type=script&lang=js"
import style0 from "./jPop.vue?vue&type=style&index=0&id=5120c966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5120c966",
  null
  
)

export default component.exports